import { render, staticRenderFns } from "./hr.vue?vue&type=template&id=485d602f&"
import script from "./hr.vue?vue&type=script&lang=js&"
export * from "./hr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports